// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__DmxXk","spin":"Spinner_spin__v9PAG"};